module.exports = __webpack_public_path__ + "static/media/salereturn-new.d833ef07.svg";